import { EDestinationType } from '@/core/interfaces';
import { Logger } from '@/shared/logger/logger';

import { DestinationBundle } from './bundles/abstract';
import { ExampleDestinationBundle } from './bundles/example/example_destination';
import { GoogleAdsDestinationBundle } from './bundles/google_ads/google_ads_destination';
import { GA4DestinationBundle } from './bundles/google_analytics_4/ga4_destination';
import { GTMDestinationBundle } from './bundles/google_tag_manager/gtm_destination';
import { MableDestinationBundle } from './bundles/mable/mable_destination';
import { MetaDestinationBundle } from './bundles/meta/meta_destination';
import { PinterestDestinationBundle } from './bundles/pinterest/pinterest_destination';
import { SGTMDestinationBundle } from './bundles/sgtm/sgtm_destination';
import { TikTokDestinationBundle } from './bundles/tiktok/tiktok_destination';
import { WSGTMDestinationBundle } from './bundles/wsgtm/wsgtm_destination';

export type TDestinationBundle =
  | ExampleDestinationBundle
  | GoogleAdsDestinationBundle
  | MableDestinationBundle;

export const DestinationBundleBuilder = {
  build(
    type: EDestinationType,
    destinationId: string,
    destinationConfig: any,
  ): DestinationBundle | null {
    try {
      switch (type) {
        case EDestinationType.Example: {
          return new ExampleDestinationBundle(destinationConfig, destinationId);
        }
        case EDestinationType.Mable: {
          return new MableDestinationBundle(destinationConfig, destinationId);
        }
        case EDestinationType.GoogleAds: {
          return new GoogleAdsDestinationBundle(
            destinationConfig,
            destinationId,
          );
        }
        case EDestinationType.GA4:
        case EDestinationType.GoogleAnalytics: {
          return new GA4DestinationBundle(destinationConfig, destinationId);
        }
        case EDestinationType.GTM: {
          return new GTMDestinationBundle(destinationConfig, destinationId);
        }
        case EDestinationType.Facebook: {
          return new MetaDestinationBundle(destinationConfig, destinationId);
        }
        case EDestinationType.SGTM: {
          return new SGTMDestinationBundle(destinationConfig, destinationId);
        }
        case EDestinationType.WSGTM: {
          return new WSGTMDestinationBundle(destinationConfig, destinationId);
        }
        case EDestinationType.TikTok: {
          return new TikTokDestinationBundle(destinationConfig, destinationId);
        }
        case EDestinationType.Pinterest: {
          return new PinterestDestinationBundle(
            destinationConfig,
            destinationId,
          );
        }
        default: {
          Logger.warn(`No destination implemented for this type ${type}`);
          return null;
        }
      }
    } catch (error) {
      Logger.error(
        `Error building destination bundle: ${error as any} with type ${type} and id ${destinationId}`,
      );
      return null;
    }
  },
};
